<div class="d-flex justify-content-between align-items-center mb-3">
  <div class="position-relative" dropdown>
    <button
      id="button-perPage"
      dropdownToggle
      type="button"
      class="btn btn-outline-default btn-sm dropdown-toggle"
      aria-controls="dropdown-perPage"
    >
      Show {{ perPage }} <span class="caret"></span>
    </button>
    <ul
      id="dropdown-perPage"
      *dropdownMenu
      class="dropdown-menu"
      role="menu"
      aria-labelledby="button-perPage"
    >
      <li role="menuitem">
        <a (click)="onSetPerPage(10)" class="dropdown-item">10</a>
      </li>
      <li role="menuitem">
        <a (click)="onSetPerPage(25)" class="dropdown-item">25</a>
      </li>
      <li role="menuitem">
        <a (click)="onSetPerPage(50)" class="dropdown-item">50</a>
      </li>
      <li role="menuitem">
        <a (click)="onSetPerPage(100)" class="dropdown-item">100</a>
      </li>
    </ul>
  </div>
  <div>
        <input type="text" class="form-control form-control-sm" placeholder="Search..." aria-label="Search" [(ngModel)]="search" (ngModelChange)="onSearch()">
  </div>
</div>
<div class="table-responsive">
<table class="table table-hover data-table {{tableClass}}" [attr.id]="tableId ? tableId : null">
  <thead>
    <tr>
      <th
        *ngFor="let col of cols"
        [ngClass]="{ sortable: col.sortable,'text-end':col?.textAlign == 'end', 'text-start':col?.textAlign == 'start', 'text-center':col?.textAlign == 'center' }"
        tabindex="0"
        (click)="onSetSort(col)"
      >
        {{ col.name }}
        <span *ngIf="col.sortable" class="data-table-sort-indicators">
          <i
            class="bx bxs-up-arrow-alt"
            [ngClass]="{
              'data-table-sort-active': order == 'asc' && sort == col.id
            }"
          ></i>
          <i
            class="bx bxs-down-arrow-alt"
            [ngClass]="{
              'data-table-sort-active': order == 'desc' && sort == col.id
            }"
          ></i
        ></span>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let row of sortRows(rows); let index = index">
      <tr *ngIf="index >= (page - 1) * perPage && index < page * perPage">
        <td *ngFor="let col of cols" [ngClass]="{'text-end':col?.textAlign == 'end', 'text-start':col?.textAlign == 'start', 'text-center':col?.textAlign == 'center'}">
          <ng-container *ngIf="col.buttons">
            <ng-container *ngFor="let button of col.buttons">
              <a
                class="btn btn-sm btn-darken rounded-pill me-1"
                [routerLink]="getButtonLink(button, col, row)"
                (click)="onButtonPress(button, row)"
                [tooltip]="button.tooltip ? button.tooltip : null"
                [delay]="300"
                >{{ button.text
                }}<i class="{{ button.icon }}" *ngIf="button.icon"></i
              ></a>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!col.buttons">
            <div [innerHtml]="row[col.dataRef ? col.dataRef  : col.id] | formatDataTableData: col"></div>
          </ng-container>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
</div>
<div class="d-flex justify-content-between align-items-center {{paginationClass}}">
  <div>
    Showing {{ (page - 1) * perPage + 1 }} -
    <ng-container *ngIf="page * perPage < rows.length">{{
      page * perPage
    }}</ng-container
    ><ng-container *ngIf="page * perPage >= rows.length">{{
      rows.length
    }}</ng-container>
    of {{ rows.length }}
     <ng-container *ngIf="allRows && search">(Filtered from {{allRows.length}})</ng-container>
  </div>
  <pagination [totalItems]="rows.length" [(ngModel)]="page" [itemsPerPage]="perPage" [maxSize]="20"></pagination>
</div>
